import React, { useRef, useState, useEffect } from 'react';
import Preview from './components/Preview';
import PreviewDownload from './components/PreviewDownload';
import Form from './components/Form';

const detectInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /Line/i.test(userAgent) || /Twitter/i.test(userAgent);
};

const App = () => {
  const [animalType, setAnimalType] = useState('猫');
  const [imageUrl1, setImageUrl1] = useState('');
  const [imageUrl2, setImageUrl2] = useState('');
  const [email, setEmail] = useState('');
  const [twitterHandle, setTwitterHandle] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');  // 電話番号の状態を追加
  const [missingDate, setMissingDate] = useState('');
  const [missingLocation, setMissingLocation] = useState('');
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [age, setAge] = useState('');
  const [collar, setCollar] = useState('');
  const [features, setFeatures] = useState('');
  const [notes, setNotes] = useState('');
  const [isInAppBrowser, setIsInAppBrowser] = useState(false);  // アプリ内ブラウザ検出用

  const previewRef = useRef<HTMLDivElement>(null);
  const hiddenPreviewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (detectInAppBrowser()) {
      setIsInAppBrowser(true);  // アプリ内ブラウザの場合にtrueに設定
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 relative flex flex-col items-center py-10">
      {/* アプリ内ブラウザでの案内メッセージ */}
      {isInAppBrowser && (
        <div className="fixed top-0 left-0 right-0 bg-yellow-500 text-white p-4 text-center">
          <p>標準ブラウザで開くことを推奨しています。外部ブラウザで開くには
            <a
              href={`https://uskado.com/tools/?openExternalBrowser=1`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline ml-2"
            >
              ここをクリック
            </a>
          </p>
        </div>
      )}

      {/* 表示用プレビュー */}
      <div className="fixed bottom-0 right-0 m-4 transform scale-75">
        <Preview
          ref={previewRef}
          animalType={animalType}
          imageUrl1={imageUrl1}
          imageUrl2={imageUrl2}
          email={email}
          twitterHandle={twitterHandle}
          phoneNumber={phoneNumber}  // 電話番号を渡す
          missingDate={missingDate}
          missingLocation={missingLocation}
          name={name}
          gender={gender}
          age={age}
          collar={collar}
          features={features}
          notes={notes}
        />
      </div>
      
      {/* 画像生成用の隠しプレビュー */}
      <div style={{ position: 'absolute', top: '-10000px', left: '-10000px' }}>
        <PreviewDownload
          ref={hiddenPreviewRef}
          animalType={animalType}
          imageUrl1={imageUrl1}
          imageUrl2={imageUrl2}
          email={email}
          twitterHandle={twitterHandle}
          phoneNumber={phoneNumber}  // 電話番号を渡す
          missingDate={missingDate}
          missingLocation={missingLocation}
          name={name}
          gender={gender}
          age={age}
          collar={collar}
          features={features}
          notes={notes}
        />
      </div>

      <Form
        animalType={animalType}
        setAnimalType={setAnimalType}
        setImageUrl1={setImageUrl1}
        setImageUrl2={setImageUrl2}
        email={email}
        setEmail={setEmail}
        twitterHandle={twitterHandle}
        setTwitterHandle={setTwitterHandle}
        phoneNumber={phoneNumber}  // 電話番号
        setPhoneNumber={setPhoneNumber}  // 電話番号のsetter
        missingDate={missingDate}
        setMissingDate={setMissingDate}
        missingLocation={missingLocation}
        setMissingLocation={setMissingLocation}
        name={name}
        setName={setName}
        gender={gender}
        setGender={setGender}
        age={age}
        setAge={setAge}
        collar={collar}
        setCollar={setCollar}
        features={features}
        setFeatures={setFeatures}
        notes={notes}
        setNotes={setNotes}
        previewRef={hiddenPreviewRef}
      />
    </div>
  );
};

export default App;
